import { datadogRum } from '@datadog/browser-rum';

/**
 * Distinct dedupe keys per reporting path — a React render error and a WASM
 * runtime error are different failure modes that should each be observable
 * once per browser session (PRCM-10704).
 */
export const ANIMATION_PREVIEW_RENDER_ERROR_DEDUPE_KEY = 'pod:animation-preview-render-error-reported';
export const ANIMATION_PREVIEW_RUNTIME_ERROR_DEDUPE_KEY = 'pod:animation-preview-runtime-error-reported';

/**
 * Report an animation-preview error to Datadog RUM at most once per browser
 * session for the given dedupe key.
 *
 * Used by both the ErrorBoundary render-error path and the window 'error'
 * listener that watches for Unity WASM runtime errors, so a broken artifact
 * deployment can't spam RUM (~1,185 events in an hour observed in a single
 * session before this guard existed).
 */
export const reportAnimationPreviewErrorOnce = (
  dedupeKey: string,
  error: Error,
  meta: Record<string, unknown> = {},
): void => {
  try {
    if (window.sessionStorage.getItem(dedupeKey)) {
      return;
    }
    window.sessionStorage.setItem(dedupeKey, '1');
  } catch {
    // sessionStorage can throw in private modes / disabled storage. Fall
    // through and still report — better a duplicate than silent loss.
  }
  datadogRum.addError(error, meta);
};
